export const tr = {
    ads: {
        one: '{count} ad',
        some: '{count} ads',
        many: '{count} ads',
        none: '{count} ads'
    },
    groups: {
        one: '{count} ad group',
        some: '{count} ad groups',
        many: '{count} ad groups',
        none: '{count} ad groups'
    },
    keywords: {
        one: '{count} keyword',
        some: '{count} keywords',
        many: '{count} keywords',
        none: '{count} keywords'
    },
    'title-ads': 'Status of ads in the group',
    'title-groups': 'Status of groups in the campaign',
    'title-keywords': 'Status of keywords in the group'
};
